import { NODE_API_BASE } from '../config/node-api.js';
import { API } from '../config/api';
import axios from 'axios';
import loadjs from 'loadjs';

export const getToken = (email, password) =>
  axios.post(`${NODE_API_BASE}/api/token`, { email, password })
    .then(response => response.data.token);


export const getUser = () =>
  axios.get(`${NODE_API_BASE}/api/user/me`)
    .then((response) => response.data);


export const updateUser = (user) =>
  axios.post(NODE_API_BASE + '/api/user/me', user).then(response => response.data);


export const registerUser = (user) => {
  return axios.post(`${NODE_API_BASE}/api/user`, user).then((response) => user);
}

export const newsletterSubscribe = (newsletters) =>
  axios.post(NODE_API_BASE + '/api/newsletters/subscribe', newsletters);

export const getUserNewsSub = () =>
  axios.get(NODE_API_BASE + '/api/newsletters')
    .then(response => response.data);

export const resetUserPassword = (email) =>
  axios.post(NODE_API_BASE + '/api/passwordReset', { email: email })
    .then(response => response.data);

export const updateUserPasswordWithToken = (newPassword, resetToken) =>
  axios.put(`${NODE_API_BASE}/api/passwordReset`, { resetToken: resetToken, newPassword: newPassword })
    .then(response => response.data);

export const magazineSubscribe = (form) =>
  axios.post(NODE_API_BASE + '/api/subscriptions/subscribe', { form });

export const promomagazineSubscribe = (form) =>
  axios.post(NODE_API_BASE + '/api/promosubscriptions/promosubscribe', { form });


function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export const mediaKitRegister = (form) => {
  form['phone_number'] = [...form['phone_number']].map(dig => isNumeric(dig) ? dig : '').join('');
  return axios.post(NODE_API_BASE + '/api/mediakit', { form })
    .then(response => response.data)
    .catch(error => console.log(error));
}

export const getWebinar = (webinarId) => axios.get(`${API}/wp-json/wp/v2/webinars/${webinarId}`);

// TODO: Remove once sp endpoint is ready
export const getWebinarFormFields = (webinarId) =>
  axios.get(`${NODE_API_BASE}/api/webinars/${webinarId}/fields`)
    .then(response => response.data);


// TODO: Determine how form data is passed to api
export const submitWebinarRegistration = ({ form, webinarId, upcomingWebinar, title }) =>
  axios.post(`${NODE_API_BASE}/api/webinars/register/${webinarId}`, { form, webinarId, upcomingWebinar, title });

export const validatePromoCode = (promoCode) =>
  axios.post(`${NODE_API_BASE}/api/promocode/validate`, { promoCode }).then(res => res.data);

export const getMagazineIssues = () => {
  return axios.get(`${API}/wp-json/wp/v2/issues/`, {
    params: {
      per_page: 38
    }
  }).then((response) => {
    return {
      past: response.data.filter(issue => issue.acf.special === false).slice(1, response.data.length),
      special: response.data.filter(issue => issue.acf.special === true),
      recent2: response.data.filter(issue => issue.acf.special === false).slice(0, 2)
    }
  }).catch((error) => {
    console.log(error);
  });
}

export const getMagazineCurrentIssue = () =>
  axios.get(`${API}/wp-json/acf/v3/options/options/current_issue`)
    .then(response =>
      axios.get(API + '/wp-json/wp/v2/issues/' + response.data.current_issue.ID)
        .then((response) => response.data)
  )


  
export const getDailyVideo = () =>
  axios.get(`${API}/wp-json/sp/v1/daily_video`)

    .then((response) => {
       if(!response.data) return false;
       if(navigator.userAgent.indexOf("bot") !== -1) return false;                      
       if(navigator.userAgent.indexOf("crawl") !== -1) return false;
       if(navigator.userAgent.indexOf("spider") !== -1) return false;      
       if(window.location.pathname.indexOf("videos") === -1) return false;
         
             
      const VIDEO_ID = response.data.video_id;

      return new Promise((resolve, reject) => {
        loadjs(['https://apis.google.com/js/api.js'], {
          success: () => {
            //if(navigator.userAgent.indexOf("Chrome") !== -1){              
                //window.alert('hi chrome');
            //    console.log('hello chrome');    
                getVideo(VIDEO_ID, resolve, reject);
            //}
          },
          error: function (err, reject) {
            reject(err);
          }
        });
      });
    })

const getVideo = (videoID, resolve, reject) => {
  window.gapi.load('client', () => {
    window.gapi.client.init({
      apiKey: 'AIzaSyC2h5cUW0sacuQ0s5Ohc7ZrdKoo-8lFjOI'
    }).then(() => {
      let request = window.gapi.client.request({
        method: 'GET',
        path: '/youtube/v3/videos',

        params: {
          id: videoID,
          part: 'id, snippet, contentDetails, player'
        }
      });

      request.execute((response) => {
        if (response.items.length === 0) {
          return;
        }

        let item = response.items[0];
        let video = {
          id: item.id,
          //published_at: item.contentDetails.videoPublishedAt,
          published_at: item.snippet.publishedAt,
          duration: item.contentDetails.duration,    
          channel_id: item.snippet.channelId,
          channel_name: item.snippet.channelTitle,
          description: item.snippet.description.split(/\s?(For more)\s?/)[0],
          thumbnail: item.snippet.thumbnails,
          title: item.snippet.title,
          player: item.player.embedHtml
        }

        resolve(video);
      });
    });
  });
}


// WEBPACK FOOTER //
// ./src/api/index.js